export const RECON_SCORE_DISPLAY_CAP = 999;

/** Scores are unbounded on the wire; the display caps at ±999%. */
export function formatReconScore(score: number): string {
    if (score > RECON_SCORE_DISPLAY_CAP) return `>${RECON_SCORE_DISPLAY_CAP}%`;
    if (score < -RECON_SCORE_DISPLAY_CAP) return `<-${RECON_SCORE_DISPLAY_CAP}%`;
    return `${score}%`;
}

/** The exact figure for a capped score's title / aria-label; undefined when nothing was capped. */
export function exactScoreTitle(score: number): string | undefined {
    return Math.abs(score) > RECON_SCORE_DISPLAY_CAP ? `Exact: ${score.toLocaleString('en-IN')}%` : undefined;
}
